module.exports = __webpack_public_path__ + "static/img/Jade Liu.d2430f67.png";